<template>
  <section class="container">
    <el-form>
      <el-form-item label="图片">
        <el-upload
          class="upload-demo"
          :action="uploadDomain"
          :data="uploadData"
          :on-success="uploadSuccess"
          :show-file-list="false"
          list-type="picture">
          <el-button
            size="small"
            type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <img
          v-if="aboutUs.img"
          :src="qiniuDomain + aboutUs.img"
          class="about-img" >
      </el-form-item>
      <el-form-item label="英文图片">
        <el-upload
          class="upload-demo"
          :action="uploadDomain"
          :data="uploadData"
          :on-success="uploadEnglishSuccess"
          :show-file-list="false"
          list-type="picture">
          <el-button
            size="small"
            type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <img
          v-if="aboutUs.english_img"
          :src="qiniuDomain + aboutUs.english_img"
          class="about-img" >
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="onSave">保存</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  aboutUs, aboutUsEdit,
} from '@/api/about'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      aboutUs: {
        english_img: '',
        img: '',
        uuid: '',
      },
    };
  },

  created() {
    this.network().getQiniuInfo()
    this.network().aboutUs()
  },
  methods: {
    routerTo(url) {
      this.$router.push({
        path: url,
      })
    },
    onSave() {
      this.network().aboutUsEdit()
    },
    uploadSuccess(res) {
      this.aboutUs.img = res.hash
      // this.network().aboutUsEdit(res.hash)
    },
    uploadEnglishSuccess(res) {
      this.aboutUs.english_img = res.hash
      // this.network().aboutUsEdit(res.hash)
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        aboutUs: async () => {
          const { status, data } = await aboutUs()
          if (status === 200) {
            this.aboutUs = data
          }
        },
        aboutUsEdit: async () => {
          const { status } = await aboutUsEdit(this.aboutUs)
          if (status === 200) {
            this.$message({
              message: '更新成功',
              type: 'success',
            })
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
  .about-img {
    max-width: 800px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/about/about.vue